"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxItemsNumber = exports.algoliaDomains = void 0;
var algoliaDomains = exports.algoliaDomains = ['algolia.net', 'algolianet.com', 'algolia.com'];
var maxItemsNumber = exports.maxItemsNumber = 20;